import { render, staticRenderFns } from "./TrackingOrder.vue?vue&type=template&id=742e425c"
import script from "./TrackingOrder.vue?vue&type=script&lang=js"
export * from "./TrackingOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports